import React, { Component } from 'react';
import NavBar from './navbar.js';
import Footer from './footer.js';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import EmpresaDisplay from './EmpresaDisplay.js';
import { properties } from './properties.js';
import { withTranslation } from 'react-i18next';
import i18n from './I18N/I18n.js'; 
import {logout, cargarIdiomaPreferido, apiSecuredRequest, isUserOrWallet, setBearer, isRootWallet} from './functions.js';
import './css/listaEmpresas.css';

class ListaEmpresas extends Component {

    async componentDidMount() {
        
        await cargarIdiomaPreferido(this.cambiarIdioma);
        // 1. Carga de Lista de empresas
        await this.checkIfWeb3UserOrLoginUser()
  
    }

      cambiarIdioma = (idioma) => {
          const { i18n } = this.props;
          i18n.changeLanguage(idioma); 
          this.forceUpdate(); 
          Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
      };
       
      logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
      }

      async checkIfWeb3UserOrLoginUser() { 
        localStorage.removeItem('empresa');
        const email = Cookies.get("email");
        this.setState({ email: email });
        let bearerVar = Cookies.get("id");
        this.setState({ bearer: bearerVar });
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        let account = await isUserOrWallet(email, bearerVar);
        const bearerToken = await setBearer(email, bearerVar, account);
        Cookies.set('id', bearerToken);
        this.setState({bearer: bearerToken})
        const isRootDir = await isRootWallet(account);
        this.setState({isRootDir: isRootDir});
        
        this.setState({account: account});
        var empresasList;
        
        if (isRootDir == true || userRol == properties.rootUserRol) {
      

          let empresasList;

          try {
              empresasList = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/all`, "", bearerToken);
          } catch (error) {
              console.error("Error al obtener la lista de todas las empresas:", error);
          
              Swal.fire({
                  title: `${i18n.t('errorOccurred')}`,
                  confirmButtonText: `${i18n.t('continue')}`,
                  confirmButtonColor: '#E94981',
                  icon: 'info',
                  iconColor: '#66C08B',
                  width: '560px',
              });
          
              empresasList = null; // Manejo de error: puedes cambiar esto según lo necesites
          }
          
                      
              const sortedBrands = [...empresasList.data].sort((a, b) => a.name.localeCompare(b.name));
          
              this.setState({ empresas: sortedBrands })
              this.setState({isRootDir: true}) 
              
        }else{
          

          if(typeof bearerVar === 'undefined'){
                  Swal.fire({
                    title: `${i18n.t('connect')}`,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Finish'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      
                      window.location.href = `/`;
                      
                    }
                  });
            }else{
            try{
            

              let empresasList;

              try {
                  empresasList = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/usuarioId`, "", bearerVar);
              } catch (error) {
                  console.error("Error al obtener la lista de empresas:", error);
                  empresasList = null; // O cualquier valor por defecto que desees manejar
                  Swal.fire({
                    title: `${i18n.t('errorOccurred')}`,
                    confirmButtonText: `${i18n.t('continue')}`,
                    confirmButtonColor: '#E94981',
                    icon: 'info',
                    iconColor: '#66C08B',
                    width: '560px',
                })
              }
                    
                    const sortedBrands = [...empresasList.data].sort((a, b) => a.name.localeCompare(b.name));
                  
        
                    this.setState({ empresas: sortedBrands })
        
                    } catch (error) {   
                        if (error.response) {
                          this.setState({empresas: null})
                          if (error.response.status === 401) {
                            window.location.href="/"
                          }
                        }
                    }

          }
          


        }
        
  }

    constructor(props) {
        super(props)
        this.state = {
          empresas: null,
          account: null, 
          isRootDir: false,
          email: null, 
          userRol: null,
          bearer: null
        }
      }

    render() {

        if (this.state.isRootDir == false && this.state.email == null && this.state.bearer == null) {
            return (
                <>
             <div className="no-login-container">
  <div className="header-container">
    {/* Botón para agregar un nuevo certificado */}
  </div>
  
  <div className="table-container">
    <table className="message-table">
      <thead>
        <tr>
          <th>
            <h1>Neither Root wallet or user connected</h1>
          </th>
        </tr>
      </thead>
    </table>
  </div>
</div>
              </>
              );
          }else if (this.state.empresas != 0 && (this.state.isRootDir == true || this.state.userRol==properties.rootUserRol)) {
      
         return (
            <>
          <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
              <div className="empresas-container">
              <h1>{i18n.t('Marcas')}</h1>
                <div className="empresas-header">
  
              <button className="add-brand-button" onClick={() => window.location.href = '/addBrand'}>
                {i18n.t('addBrand')}
              </button>
            </div>
                  <table className="empresas-table">
                    <EmpresaDisplay items={this.state.empresas} />
                  </table>
             </div>    

          <Footer />
          </>
        );
      } else if(this.state.empresas != 0 && this.state.isRootDir == false ){
        return (
          <>
         <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
              <div className="empresas-container">
              <h1>{i18n.t('Marcas')}</h1>
                <div className="empresas-header">
  
              
            </div>
                  <table className="empresas-table">
                    <EmpresaDisplay items={this.state.empresas} />
                  </table>
             </div>    

          <Footer />
        </>
      );

      }else{
        return (
          <>
        

         <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
              <div className="empresas-container">
              <h1>{i18n.t('Marcas')}</h1>
                <div className="empresas-header">
  
              <button className="add-brand-button" onClick={() => window.location.href = '/addBrand'}>
                {i18n.t('addBrand')}
              </button>
            </div>
            <h1>{i18n.t('noEmpresas')}</h1>
             </div>    

          <Footer />

           
        </>
      );
      }
    }
}



export default  withTranslation()(ListaEmpresas);